<template>

    <b-modal
        id="element-preview-modal"
        size="lg"
        :title="t.__('Przeglądaj materiały marketingowe')"
        :ok-title="t.__('Zamknij')"
        ok-variant="secondary"
        ok-only
        no-close-on-backdrop
        @hidden="modalHandleHide">

        <div class="row">
            <div class="col">
                <p class="font-weight-bold mb-4" v-if="element">
                    <span v-if="type === 'area'">{{ t.__('Obszar') }}: </span>
                    <span v-if="type === 'package'">{{ t.__('Pakiet') }}: </span>
                    <span v-if="type === 'set'">{{ t.__('Zestaw') }}: </span>
                    <span v-if="type === 'game'">{{ t.__('Gra') }}: </span>
                    <span>{{ element.display_name }} ({{ element.output_identification_name }})</span>
                </p>
            </div>
            <div class="col text-right">
                <a href="#" class="btn btn-primary btn-sm" @click="switchToEditView">{{ t.__('Przełącz do widoku edycji') }}</a>
                <a href="#" class="btn btn-dark btn-sm" @click="switchToTranslateView">{{ t.__('Przełącz do widoku tłumaczenia') }}</a>
            </div>
        </div>

        <div class="form-group">
            <label for="language">{{ t.__('Język') }}</label>
            <select class="form-control" id="language" v-model="language">
                <option :value="null" disabled selected>{{ t.__('Wybierz') }}</option>
                <option v-for="languagesOption in languagesOptions" :value="languagesOption.id">{{ languagesOption.text }}</option>
            </select>
        </div>

        <hr class="mb-4">

        <b-tabs pills card vertical nav-wrapper-class="col-3" v-if="marketingResources.length" class="mb-3">
            <b-tab v-for="(marketingResource, index) in marketingResources" :key="index" :title="marketingResource.section_name">
                <b-card-text>
                    <p v-html="marketingResource.content"></p>
                </b-card-text>
            </b-tab>
        </b-tabs>

        <div class="mt-4" v-for="(childMarketingResource, type) in childMarketingResources">

            <p v-if="type === 'packages' && Object.keys(childMarketingResource).length">{{ t.__('Pakiety') }}</p>
            <p v-if="type === 'sets' && Object.keys(childMarketingResource).length">{{ t.__('Zestawy') }}</p>
            <p v-if="type === 'games' && Object.keys(childMarketingResource).length">{{ t.__('Gry') }}</p>

            <b-tabs pills card vertical nav-wrapper-class="col-3" v-if="Object.keys(childMarketingResource).length" class="mb-3">
                <b-tab v-for="(content, name) in childMarketingResource" :key="name" :title="name">
                    <b-card-text>
                        <p v-html="content"></p>
                    </b-card-text>
                </b-tab>
            </b-tabs>

        </div>

        <file-manager-browse :base-path="fileManagerPath" :button-text="t.__('Przeglądaj pliki')" :disable-write-access="true"></file-manager-browse>

        <a :href="generatePdfRoute" target="_blank" class="btn btn-sm btn-warning">{{ t.__('Generuj PDF') }}</a>

    </b-modal>

</template>

<script>

    export default {

        name: 'MarketingResourcesElementPreviewModal',

        props: [
            'languages'
        ],

        data() {
            return {
                eventHub: window.eventHub,
                type: null,
                element: null,
                languagesOptions: [],
                language: 'en',
                marketingResources: [],
                childMarketingResources: [],
                fileManagerPath: null,
                generatePdfRoute: null
            }
        },

        watch: {
            language: function () {
                localStorage.setItem('marketingResourcesLang', this.language);
                this.load();
            }
        },

        beforeMount() {

            this.languages.forEach(language => {
                this.languagesOptions.push({
                    text: language.name,
                    id: language.code
                });
            });

        },

        mounted() {

            this.eventHub.$on('marketing-resources-preview', (type, element) => {
                if (![null, undefined, 'null', 'undefined'].includes(localStorage.getItem('marketingResourcesLang'))) {
                    this.language = localStorage.getItem('marketingResourcesLang');
                } else {
                    this.language = 'pl';
                }
                this.type = type;
                this.element = element;
                this.generatePdfRoute = route('game::marketing-resources.download-pdf', {elementType: this.type, elementId: this.element.id, language: this.language});
                this.load();
            });

        },

        methods: {

            load() {
                this.eventHub.$emit('processing-start');
                axios.get(route('game::marketing-resources.get-element-resources', {elementType: this.type, elementId: this.element.id, language: this.language}) + '?with-child-resources=1')
                    .then(response => {
                        this.marketingResources = response.data.data.data.map(section => {
                            return {
                                id: (section.resources !== null && section.resources[0] !== undefined) ? section.resources[0].id : null,
                                section_id: section.id,
                                section_name: section.name !== null ? section.name : ('(' + section.name_in_base_language + ')'),
                                content: (section.resources !== null && section.resources[0] !== undefined) ? section.resources[0].content : '',
                            };
                        })
                        this.childMarketingResources = response.data.data.child_resources;
                        this.fileManagerPath = response.data.data.file_manager_path;
                        this.eventHub.$emit('processing-finish');
                        this.$bvModal.show('element-preview-modal');
                    })
                    .catch(error => {
                        console.log(error);
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', t.__('Coś poszło nie tak.'), 'error');
                    });
            },

            switchToEditView() {
                this.eventHub.$emit('marketing-resources-edit', this.type, this.element);
                this.$bvModal.hide('element-preview-modal');
            },

            switchToTranslateView() {
                this.eventHub.$emit('marketing-resources-translate', this.type, this.element);
                this.$bvModal.hide('element-preview-modal');
            },

            modalHandleHide() {
                this.type = null;
                this.element = null;
                this.fileManagerPath = null;
                this.generatePdfRoute = null;
            }

        }

    }
</script>

<style scoped>

    /deep/ .nav.nav-pills .nav-item .nav-link {
        border-radius: .25rem;
    }

    /deep/ .nav.nav-pills .nav-item .nav-link.active {
        color: white;
    }

    /deep/ .tabs {
        border: 1px solid #e5e5e5;
        border-radius: .25rem;
    }

    /deep/ .tabs .tab-content {
        border: none;
        padding-top: 0;
    }

</style>
